import {initializeFaro} from '@grafana/faro-web-sdk';
import ENV from '../../environment';

export function buildFaroConfig(
  url: string | undefined,
  appEnv: string | undefined,
  release: string | undefined,
) {
  if (!url) return null;
  return {
    url,
    // No per-request resource events: one Loki line per fetch/xhr is too
    // noisy and logs full URLs incl. query strings.
    trackResources: false,
    app: {
      name: 'cc-web-learning',
      version: release,
      environment: appEnv === 'preprod' ? 'preprod' : 'prod',
    },
  };
}

export function initFaro() {
  const config = buildFaroConfig(
    ENV.FARO_URL,
    process.env.APP_ENV,
    process.env.SENTRY_RELEASE,
  );
  if (!config) return;
  try {
    initializeFaro(config);
  } catch (e) {
    // Telemetry must never break the app.
    console.warn('Faro init failed', e);
  }
}
